import { dataURLtoBlob } from "../../../../../_4threal/helpers";
import { uploadBlob } from "../../../../../redux/action/card";
import { Canvg } from "canvg";
import { jsPDF } from "jspdf";

export const makePng: any = (svgEl: any, widthBorder = 0, heightBorder = 0, upload = '', title = 'imageTitle') => (dispatch: any) => {
  return new Promise(async (resolve, reject) => {
    if (svgEl === null) {
      resolve('Error: svg element is null')
    }
    try {
      console.log('makePng', svgEl)
      // Get SVG data as a string
      const svgData = await convertSvgImagesToDataUrls(new XMLSerializer().serializeToString(svgEl));

      const bbox = svgEl.getBBox();
      const width = bbox.width;
      const height = bbox.height;
      const scale = [width, height];
      const canvas = document.createElement('canvas');
      canvas.width = scale[0] + (2 * widthBorder); // Include border width on both sides
      canvas.height = scale[1] + (2 * heightBorder); // Include border height on both sides
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        throw new Error('Could not get canvas context');
      }

      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Create a new canvas for the SVG
      const svgCanvas = document.createElement('canvas');
      svgCanvas.width = scale[0];
      svgCanvas.height = scale[1];
      const svgCtx: any = svgCanvas.getContext('2d');
      const v = Canvg.fromString(svgCtx, svgData);
      await v.render();

      // Draw the SVG canvas onto the main canvas, offset by the border dimensions
      ctx.drawImage(svgCanvas, widthBorder, heightBorder);

      const imgData = canvas.toDataURL('image/png');
      // console.log(imgData)

      if (upload) {
        const blob = dataURLtoBlob(imgData);
        const uploadImg = await dispatch(
          uploadBlob({
            blob: blob,
            filename: `${title}.print.${upload}.png`,
            dirs: ['cards'],
            setUser: true,
          })
        );

        resolve(uploadImg);
      }

      resolve(imgData);
    } catch (error) {
      reject(error);
      console.error('Error during makePng:', error);
    }
  })
}

async function convertSvgImagesToDataUrls(svgString) {
  const parser = new DOMParser();
  const svgDom = parser.parseFromString(svgString, 'image/svg+xml');

  // Find all image tags in the SVG
  const images = svgDom.querySelectorAll('image');
  for (const img of images) {

    const href = img.getAttribute('xlink:href') || img.getAttribute('href');
    if (href) {
      try {

        if (img.getAttribute('id') === 'qrcode') {
          //convert to png
          const svgQrCode = await fetch(href).then(res => res.text());
          const pngDataUrl:any = await convertSvgToPng(svgQrCode);
          img.setAttribute('xlink:href', pngDataUrl);
        }else{
          const dataUrl: any = await fetchImageAsDataUrl(href);
          img.setAttribute('xlink:href', dataUrl); // Set the new data URL
        }
      } catch (error) {
        console.error('Failed to fetch or convert image:', error);
      }
    }
  }

  // Serialize the updated SVG back to a string
  const serializer = new XMLSerializer();
  return serializer.serializeToString(svgDom);
}

async function convertSvgToPng(svgContent) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx:any = canvas.getContext('2d');

    const img = new Image();
    const svgBlob = new Blob([svgContent], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(svgBlob);

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      URL.revokeObjectURL(url);
      const pngDataUrl = canvas.toDataURL('image/png');
      resolve(pngDataUrl);
    };

    img.onerror = (err) => {
      reject(err);
    };

    img.src = url;
  });
}

async function fetchImageAsDataUrl(url) {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export const downloadFile = (type = 'svg', svgEl = null, marker, dispatch) => {
    if (type === 'svg') {
      downloadSVG(svgEl)
    } else if (type === 'pdf') {
      downloadPDF(svgEl, marker)
    } else if (type === 'png') {
      downloadPNG(svgEl, dispatch)
    }
}

const downloadSVG = async (svgEl) => {
  if (svgEl === null) {
    return
  }
  let filename = 'My Background';
  let name = `${filename}.svg`;
  const svgData = await convertSvgImagesToDataUrls(new XMLSerializer().serializeToString(svgEl));
  const blob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

const downloadPDF = async (svgEl, marker) => {
  return new Promise(async (resolve, reject) => {
    if (svgEl === null) {
      console.error('error in downloading pdf, svgElement is null')
      return
    }
    let filename = 'My Background';
    let name = `${filename}.pdf`;

    const svgData = await convertSvgImagesToDataUrls(new XMLSerializer().serializeToString(svgEl));
    const scale = getScale(marker);
    const canvas = document.createElement('canvas');

    canvas.width = scale[0];
    canvas.height = scale[1];
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Could not get canvas context');
    }
    const v = Canvg.fromString(ctx, svgData);
    await v.render();
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF();
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    // Add the image with all required parameters
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(name);
  })
}

const downloadPNG = async (svgEl, dispatch) => {
  if (svgEl === null) {
    return
  }
  let filename = 'My Background';
  let name: any = `${filename}.png`;
  const imgData = await dispatch(makePng(svgEl));
  const link: any = document.createElement('a');
  link.href = imgData;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

const getScale = (marker) => {
  let targetWidth = 1050;
  let targetHeight = 600;
  if (marker?.type === 'pc') {
    targetWidth = 1800;
    targetHeight = 1200;
  } else if (marker?.type === 'qr') {
    targetWidth = 1200;
    targetHeight = 1200;
  } else if (marker?.type === 'pc2') {
    targetWidth = 6600;
    targetHeight = 3300;
  } else if (marker?.type === 'pc3') {
    targetWidth = 4800;
    targetHeight = 3300;
  } else if (marker?.type === 'custom' && marker?.customDimensions) {
    // Use custom dimensions scaled to maintain quality
    const { width, height } = marker.customDimensions;
    const scaleFactor = 150; // DPI-like scaling for quality
    targetWidth = Math.round(width * scaleFactor);
    targetHeight = Math.round(height * scaleFactor);
  }
  return [targetWidth, targetHeight];
}